import { captureException } from "@sentry/nextjs";

import type { Prices } from "../domain/coinSymbols";
import type { Currency } from "../domain/currency";

import { fetchCoinGeckoPrices } from "./coinGeckoPrice";
import { fetchJupiterPrices } from "./jupiterPrice";

export async function fetchAllCoinPrices(target?: Currency): Promise<Prices> {
  try {
    return await fetchCoinGeckoPrices(target);
  } catch {
    try {
      return await fetchJupiterPrices();
    } catch {
      captureException("Both price endpoints (Coingecko and Jupiter) failed.");
    }
  }

  return {};
}
